import { Component, EventEmitter, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { Scope } from '../../models'
import { AuthService } from '../../services/auth.service'
import { FeatureFlagsService } from '../../services/feature-flag.service'
import { I18nConfigService } from '../../services/i18n-config.service'
import { ScopeService } from '../../services/scope.service'
import { map } from 'rxjs'

@Component({
    selector: 'app-mobile-sidenav',
    templateUrl: './mobile-sidenav.component.html',
    styleUrls: ['./mobile-sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MobileSidenavComponent implements OnDestroy {

  scope: Scope.T;

  readingsFeatureFlag$ = this.featureFlagsService.readings$
  reportsFeatureFlag$ = this.featureFlagsService.reports$
  watchesFeatureFlag$ = this.featureFlagsService.watches$
  wasteFeatureFlag$ = this.featureFlagsService.waste$

  isCollapsed = false;

  currentLocale$ = this.i18nConfigService.selectedLanguage$
  availableLanguages$ = this.i18nConfigService.availableLanguages$

  showProfileLink$ = this.featureFlagsService.newAuthFrontend$.pipe(
    map(({ isEnabled })=>!isEnabled)
  )

  @Output()
  onMobileSidenavToggle = new EventEmitter();

 private subscriptions = [
   this.scopeService.selectedScope$.subscribe(scope => this.scope = scope)
 ]

 constructor (
    private auth: AuthService,
    private router: Router,
    private scopeService: ScopeService,
    private i18nConfigService: I18nConfigService,
    private featureFlagsService: FeatureFlagsService
 ) { }

 ngOnDestroy (): void {
   this.subscriptions.forEach(subscription => subscription.unsubscribe())
 }

 selectLanguage (language: string): void {
   this.i18nConfigService.selectLanguage(language)
 }

 goToProfil (): void {
   const redirect = this.router.url ? `?redirect=recap${this.router.url.toString()}` : ''
   window.location.href = `${window.location.origin}/profile${redirect}`
 }

 logout (): void {
   this.auth.logout()
 }
}
